import { css, CSSObject } from "@emotion/react";
import {
  constants,
  typographyStyles,
  visuallyHiddenStyles,
} from "@newsela/angelou";

const colors = constants.colors;
const coreBlue = { 600: colors.ui.core[600], 500: colors.ui.core[500] };
const neutral400 = colors.ui.neutral[400];
const black = colors.ui.black[500];
const { heading4Obj, textXS } = typographyStyles;

css(visuallyHiddenStyles);

// --- Container ---
export const compareContrastContainer: CSSObject = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  backgroundColor: "#fff",
  padding: "16px",
  boxSizing: "border-box",
};

// --- Both section ---
export const bothSectionContainer = css({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  margin: "0.1em 0",
});

export const bottomLineInputWrapper = css({
  border: "0",
  borderBottom: `5px solid ${coreBlue[600]}`,
  width: "17em",
  marginTop: "8px",
  paddingBottom: "4px",
});

export const bottomLineInput = (isOverflowingTextarea = false) =>
  css({
    border: `1px solid ${neutral400}`,
    borderRadius: "8px",
    padding: "0.3em 0",
    backgroundColor: "transparent",
    fontWeight: "bold",
    textAlign: "center",
    width: "100%",
    color: black,
    minHeight: "38px",
    ...(isOverflowingTextarea ? textXS : heading4Obj),
    "&::placeholder": {
      color: neutral400,
    },
    "&:focus": {
      borderColor: coreBlue[600],
    },
  });

export const paragraphCss = css({
  fontWeight: "bold",
  textAlign: "center",
  color: black,
  margin: "10px 0 8px",
  ...heading4Obj,
});

export const inputsRow = css({
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-end",
  gap: "1.2em",
});

export const bothLabel = css({
  marginTop: "0.3em",
  color: black,
  fontWeight: "bold",
  fontSize: "1.5em",
  whiteSpace: "nowrap",
  textAlign: "center",
});

// Venn container
export const vennDiagramContainer = css({
  position: "relative",
  width: "100%",
  maxWidth: "883px",
  height: "360px",
  marginTop: "1em",
});

// Left & Right ovals
const circle: CSSObject = {
  width: "550px",
  height: "360px",
  border: `4px solid ${coreBlue[600]}`,
  backgroundColor: "transparent",
  borderRadius: "200px / 200px",
  zIndex: 1,
  position: "absolute",
};

export const circleLeft: CSSObject = {
  ...circle,
  left: "0",
};

export const circleRight: CSSObject = {
  ...circle,
  right: "0",
};

export const vennDiagramTextAreaContainer = (
  isStudent: boolean = false,
): CSSObject => ({
  display: "flex",
  justifyContent: "center",
  paddingTop: "70px",
  width: "100%",
  columnGap: isStudent ? "88px" : "45px",
});

export const vennDiagramTextArea = (
  section: "left" | "right" | "center",
  isStudent: boolean = false,
): CSSObject => {
  const sectionsSpecificStyles: CSSObject = {};

  if (section === "left" || section === "right") {
    sectionsSpecificStyles.width = isStudent ? "200px" : "288px";
  } else if (section === "center") {
    sectionsSpecificStyles.width = "134px";
  }

  return {
    backgroundColor: "transparent",
    height: "219px",
    resize: "none",
    zIndex: 2,
    border: `1px solid ${neutral400}`,
    borderRadius: "8px",
    padding: "0.3em",
    color: black,
    ...typographyStyles.textSObj,
    ...sectionsSpecificStyles,
    "&:focus": {
      borderColor: coreBlue[600],
    },
  };
};
